<template>
  <div class="DistributionPlaybackTimesEachArea-wrap">
    <div class="hd-title">
      <p class="title">各区播放次数分布</p>
    </div>
    <div id="DistributionPlaybackTimesEachArea">
      <DomeEchartWrap id="DistributionPlaybackTimesEachArea" ref="DistributionPlaybackTimesEachArea"></DomeEchartWrap>
    </div>
  </div>
</template>

<script>
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
export default {
  name: 'DistributionPlaybackTimesEachArea',
  components: {
    DomeEchartWrap
  },
  props: [

  ],
  data () {
    return {
      option: {
        color: ['#0026DA', '#5F15F0', '#4748DF', '#9400D5', '#C80FCB', '#0088FF', '#19F4BF', '#3CD0ED'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          icon: 'circle',
          data: [
            '南山',
            '西丽',
            '蛇口',
            '南头',
            '粤海',
            '沙河',
            '招商',
            '桃源'
            // '松岗街道',
            // '燕罗街道'
          ],
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            color: 'rgba(255, 255, 255, 0.8)'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [
              '1/20', '1/21', '1/22', '1/23', '1/24', '1/25', '1/26', '1/27', '1/28', '1/29', '1/30', '1/31', '2/1', '2/2', '2/3', '2/4', '2/5', '2/6', '2/7', '2/8', '2/9', '2/10', '2/11', '2/12', '2/13', '2/14', '2/15', '2/16', '2/17', '2/18', '2/19', '2/20', '2/21'
            ],
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#fff'
              },
              formatter: function (value) {
                let val = (+value) / 10000
                return `${val.toFixed(1)}W`
              }
            }
          }
        ],
        series: [
          {
            name: '南山',
            type: 'bar',
            stack: '街道',
            data: [382992, 322993, 282994, 272995, 222995, 372994, 402992, 382999, 322993, 282994, 272995, 222995, 372994, 402992, 382999, 282994, 282994, 272995, 272995, 282994, 402992, 382999, 222995, 282994, 272995, 222995, 372994, 402992, 382999, 322993, 282994, 272995, 222995
            ]
          },
          {
            name: '西丽',
            type: 'bar',
            stack: '街道',
            data: [222819, 190820, 242821, 202822, 222822, 202821, 222819, 242826, 190820, 242821, 202822, 222822, 202821, 222819, 242826, 242821, 242821, 202822, 202822, 242821, 222819, 242826, 222822, 242821, 202822, 222822, 202821, 222819, 242826, 190820, 242821, 202822, 222822
            ]
          },
          {
            name: '蛇口',
            type: 'bar',
            stack: '街道',
            data: [293920, 223921, 213922, 223923, 243923, 213922, 293920, 263927, 223921, 213922, 223923, 243923, 213922, 293920, 263927, 213922, 213922, 223923, 223923, 213922, 293920, 263927, 243923, 213922, 223923, 243923, 213922, 293920, 263927, 223921, 213922, 223923, 243923
            ]
          },
          {
            name: '南头',
            type: 'bar',
            stack: '街道',
            data: [492022, 452023, 322024, 312025, 292025, 422024, 492022, 432029, 452023, 322024, 312025, 292025, 422024, 492022, 432029, 322024, 322024, 312025, 312025, 322024, 492022, 432029, 292025, 322024, 312025, 292025, 422024, 492022, 432029, 452023, 322024, 312025, 292025
            ]
          },
          {
            name: '粤海',
            type: 'bar',
            stack: '街道',
            data: [272822, 212923, 222824, 202825, 212825, 222824, 322822, 302829, 212923, 222824, 202825, 212825, 222824, 322822, 302829, 222824, 222824, 202825, 202825, 222824, 322822, 302829, 212825, 222824, 202825, 212825, 222824, 322822, 302829, 212923, 222824, 202825, 212825
            ]
          },
          {
            name: '沙河',
            type: 'bar',
            stack: '街道',
            data: [322133, 292134, 282135, 252136, 232136, 282135, 322133, 302140, 292134, 282135, 252136, 232136, 282135, 322133, 302140, 282135, 282135, 252136, 252136, 282135, 322133, 302140, 232136, 282135, 252136, 232136, 282135, 322133, 302140, 292134, 282135, 252136, 232136
            ]
          },
          {
            name: '招商',
            type: 'bar',
            stack: '街道',
            data: [232233, 182234, 232235, 222236, 212236, 242235, 232233, 212240, 182234, 232235, 222236, 212236, 242235, 232233, 212240, 232235, 232235, 222236, 222236, 232235, 232233, 212240, 212236, 232235, 222236, 212236, 242235, 232233, 212240, 182234, 232235, 222236, 212236
            ]
          },
          {
            name: '桃源',
            type: 'bar',
            stack: '街道',
            data: [233443, 203444, 193445, 203446, 233446, 193445, 233443, 233450, 203444, 193445, 203446, 233446, 193445, 233443, 233450, 193445, 193445, 203446, 203446, 193445, 233443, 233450, 233446, 193445, 203446, 233446, 193445, 233443, 233450, 203444, 193445, 203446, 233446
            ]
          }
          // {
          //   name: '松岗街道',
          //   type: 'bar',
          //   stack: '街道',
          //   data: [293839, 213840, 203841, 223842, 213842, 223841, 323839, 313846, 213840, 203841, 223842, 213842, 223841, 323839, 313846, 203841, 203841, 223842, 223842, 203841, 323839, 313846, 213842, 203841, 223842, 213842, 223841, 323839, 313846, 213840, 203841, 223842, 213842
          //   ]
          // },
          // {
          //   name: '燕罗街道',
          //   type: 'bar',
          //   stack: '街道',
          //   data: [293022, 223023, 203024, 220025, 190025, 213024, 293022, 233029, 223023, 203024, 220025, 190025, 213024, 293022, 233029, 203024, 203024, 220025, 220025, 203024, 293022, 233029, 190025, 203024, 220025, 190025, 213024, 293022, 233029, 223023, 203024, 220025, 190025
          //   ]
          // }
        ]
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$refs['DistributionPlaybackTimesEachArea'].setEchartOption(this.option)
  },
  watch: {

  },
  methods: {

  }
}
</script>

<style scoped lang="stylus">
#DistributionPlaybackTimesEachArea
  height 10.75rem

.hd-title
   .title
      margin 1rem 0
      font-size .9rem
.DistributionPlaybackTimesEachArea-wrap
  padding-bottom: 1rem
</style>
